import React, { useEffect, useState } from "react";
import { useActiveMenu } from "../auth/ActiveMenuContext";
import { useNavigate } from "react-router-dom";
import "./NavBar.css";
import sidebarRoutes from "../routes/SideBarRoutes";
import { Outlet } from "react-router-dom";
import { routes } from "../routes/routes";

// ===== SVG ICON COMPONENTS =====
const BrainIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="me-2 text-white"
  >
    <path d="M10 3a4 4 0 0 0-4 4v9" />
    <path d="M14 3a4 4 0 0 1 4 4v9" />
    <path d="M10 7h4" />
    <path d="M10 11h4" />
    <path d="M10 15h4" />
  </svg>
);

const StethoscopeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="me-2 text-white"
  >
    <path d="M4 4v5a4 4 0 0 0 8 0V4" />
    <path d="M8 15v1a6 6 0 0 0 12 0v-1" />
    <path d="M12 22v-3" />
    <path d="M20 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  </svg>
);

const BoltIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="me-2 text-white"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="me-2 text-white"
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const NavBar = () => {
  const { activeMenu, setActiveMenu } = useActiveMenu();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    var menuDetails;
    if (window.location.pathname !== "/partners") {
      menuDetails = routes.find(
        (item) => item.path === window.location.pathname
      );
      if (menuDetails === undefined) {
        const sideMenu = Object.keys(sidebarRoutes).find((item) => {
          return (
            sidebarRoutes[item].find(
              (data) => data.href === window.location.pathname
            ) ??
            sidebarRoutes[item].find((data) =>
              data["subRoutes"]?.find(
                (item) => item.href === window.location.pathname
              )
            )
          );
        });
        if (sideMenu) {
          menuDetails = routes.find(
            (item) =>
              item.path !== "/" &&
              item.path
                .replace("/", "")
                .toLowerCase()
                .includes(sideMenu.split("NavItem")[0].toLowerCase())
          );
        }
      }
      if (menuDetails && menuDetails.name) {
        setActiveMenu(menuDetails.name);
        localStorage.setItem("activeMenu", menuDetails.name);
      }
    }
  }, [window.location.pathname]);

  const handleDropdownClick = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  const renderNavItems = (navItems) => {
    return navItems.map((item, index) => {
      if (item.external) {
        return (
          <li key={index} className="nav-item">
            <a
              className="nav-link navbar-text"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>{item.name}</strong>
            </a>
          </li>
        );
      } else {
        return (
          <li
            key={index}
            className={`nav-item ${dropdownOpen === index ? "open" : ""}`}
          >
            <a
              className="nav-link navbar-text"
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                if (item.subRoutes) {
                  handleDropdownClick(index);
                } else {
                  setActiveMenu(item.name);
                  navigate(item.href);
                  setIsNavOpen(false);
                }
              }}
            >
              <strong>{item.name}</strong>
            </a>
            {item.subRoutes && renderNestedSubNavItems(item.subRoutes, index)}
          </li>
        );
      }
    });
  };

  const renderNestedSubNavItems = (subRoutes, parentIndex) => {
    return (
      <ul
        className={`dropdown-menu ${
          dropdownOpen === parentIndex ? "show" : ""
        }`}
      >
        {subRoutes.map((nestedItem, nestedIndex) => (
          <li key={nestedIndex}>
            <a
              className="dropdown-item"
              href={nestedItem.href}
              onClick={(e) => {
                e.preventDefault();
                navigate(nestedItem.href);
                setDropdownOpen(null);
                setIsNavOpen(false);
              }}
            >
              {nestedItem.name}
            </a>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-custom">
        <div className="container-fluid">
          <button className="navbar-toggler" onClick={toggleNavbar}>
            ☰{" "}
          </button>
          <div
            className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ml-auto">
              {activeMenu === "Home" &&
                renderNavItems(sidebarRoutes.homeNavItems.slice(4))}
              {activeMenu === "GenAI" &&
                renderNavItems(sidebarRoutes.genaiNavItems)}
              {activeMenu === "Manage Cloud" &&
                renderNavItems(sidebarRoutes.manageCloudNavItems)}
              {activeMenu === "Migrations" &&
                renderNavItems(sidebarRoutes.migrationNavItems)}
              {activeMenu === "Security, Compliance, and Assessments" &&
                renderNavItems(sidebarRoutes.securityComplianceNavItems)}
              {activeMenu === "Industry" &&
                renderNavItems(sidebarRoutes.industryNavItems)}
              {activeMenu === "Development & Testing Services" &&
                renderNavItems(sidebarRoutes.developmentTestingNavItems)}
              {activeMenu === "About Us" &&
                renderNavItems(sidebarRoutes.aboutUsNavItems)}
              {activeMenu === "Contact Us" &&
                renderNavItems(sidebarRoutes.homeNavItems)}
            </ul>
          </div>
        </div>
      </nav>

      {activeMenu === "Home" && (
        <div
          className="d-flex flex-wrap gap-3 py-3 px-4"
          style={{ backgroundColor: "#eaf3f9", justifyContent: "center" }}
        >
          <span
            style={{
              color: "black",
              fontWeight: "bold",
              alignSelf: "center",
            }}
          >
            Our AI Driven Usecases
          </span>
          {sidebarRoutes.homeNavItems.slice(0, 4).map((item, idx) => {
            let IconComponent = null;
            switch (item.name) {
              case "LLM Insight.AI":
                IconComponent = BrainIcon;
                break;
              case "Healthcare.AI":
                IconComponent = StethoscopeIcon;
                break;
              case "Utility.AI":
                IconComponent = BoltIcon;
                break;
              case "E-commerce.AI":
                IconComponent = CartIcon;
                break;
              default:
                break;
            }

            return (
              <button
                key={idx}
                className="btn btn-primary d-flex flex-wrap"
                // className="btn btn-primary d-flex align-items-center"
                // className="d-flex justify-content-center flex-wrap gap-3 py-3"
                // className="d-flex flex-wrap gap-3 py-3 px-4"
                onClick={() => {
                  if (idx === 0) {
                    window.open(item.href, "_blank"); // only first button opens in new tab
                  } else {
                    navigate(item.href); // others route normally
                  }
                }}
              >
                {IconComponent && <IconComponent />}
                {item.name}
              </button>
            );
          })}
        </div>
      )}

      <Outlet />
    </div>
  );
};

export default NavBar;
